module.exports = __webpack_public_path__ + "427acbaf.png";